var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationPinAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.71875C10.343 8.71875 9 10.0198 9 11.625C9 13.2302 10.343 14.5312 12 14.5312C13.657 14.5312 15 13.2302 15 11.625C15 10.0198 13.657 8.71875 12 8.71875ZM12 16.4687C9.239 16.4687 7 14.3007 7 11.625C7 8.94931 9.239 6.78125 12 6.78125C14.761 6.78125 17 8.94931 17 11.625C17 14.3007 14.761 16.4687 12 16.4687ZM12 0C5.373 0 0 5.20509 0 11.625C0 16.4862 10.005 31.0106 12 31C13.964 31.0106 24 16.4203 24 11.625C24 5.20509 18.627 0 12 0Z",
    fill: "#5F73E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPinAdd);
export default __webpack_public_path__ + "static/media/LocationPinAdd.a9f40dca43d7cd5f4795b5f3ec00dd7d.svg";
export { ForwardRef as ReactComponent };